import React, { useRef, useState } from 'react';

import { ButtonGroup, LoadingButton } from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import TextField from '@atlaskit/textfield';
import { updateAccountsMapping } from 'src/services/accountsMapping';

import jira from 'src/lib/api/jira';

import Field from 'src/views/components/Form/Field';

import { PagerDutyCredentialsValidation } from './components/CredentialsValidation';

const PagerDutyCredentialsForm = ({ accountsMapping }) => {
  const formRef = useRef(null);
  const initApiKey =
    (accountsMapping
      && accountsMapping.pagerduty
      && accountsMapping.pagerduty.auth
      && accountsMapping.pagerduty.auth.api_key)
    || '';
  const [lastSavedValue, setLastSavedValue] = useState(initApiKey);

  const [value, setValue] = useState(initApiKey);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!lastSavedValue && !value) {
      setError('Field must not be empty');
      return;
    }

    const api_key = lastSavedValue ? null : value;

    if (!api_key) {
      if (!await jira.confirm('Delete API Key?')) {
        return;
      }
    }

    setLoading(true);
    setError(null);
    updateAccountsMapping({ pagerduty: { auth: { api_key } } })
      .then((res) => {
        if (
          formRef
          && formRef.current
          && formRef.current.querySelector('input')
          && api_key
        ) {
          formRef.current.querySelector('input').blur();
        }
        setLoading(false);
        const newVal =
          (res
            && res.pagerduty
            && res.pagerduty.auth
            && res.pagerduty.auth.api_key)
          || '';
        setLastSavedValue(newVal);
        setValue(newVal);
      })
      .catch((e) => {
        setError(e);
        setLoading(false);
      });
  }

  return (
    <div>
      <Heading size="small">PagerDuty Connection options</Heading>
      <form onSubmit={handleSubmit} ref={formRef} data-cy="pd-connection-form">
        <Field label="REST API Key" isRequired errorMessage={error}>
          <TextField
            isDisabled={Boolean(lastSavedValue)}
            type={Boolean(lastSavedValue) ? 'input' : 'password'}
            isCompact
            name="apiKey"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setError(null);
            }}
          />
        </Field>
        <div style={{ height: 10 }} />
        {lastSavedValue && <PagerDutyCredentialsValidation />}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '10px',
          }}
        >
          <ButtonGroup>
            {!lastSavedValue && (
              <LoadingButton appearance="primary" isLoading={loading} type="submit">
                Save
              </LoadingButton>
            )}
            {lastSavedValue && (
              <LoadingButton appearance="danger" isLoading={loading} type="submit">
                Delete
              </LoadingButton>
            )}
          </ButtonGroup>
        </div>
      </form>
    </div>
  );
};

export default PagerDutyCredentialsForm;
